import React from "react";
import Styles from "./Horarios.module.css";
import { IconClock } from "../icons/Icons";

const horario = [
    { dia: "Lunes", horas: ["17:00 – 21:00"] },
    { dia: "Martes a Viernes", horas: ["09:00 – 13:00", "17:00 – 21:00"] },
    { dia: "Sábado", horas: ["09:00 – 13:00"] },
];

function Horarios() {
    return (
        <section id="horario" className={Styles.wrap}>
            <div className={Styles.head}>
                <IconClock className={Styles.icon} />
                <h2 className={Styles.title}>Horarios</h2>
            </div>
            <ul className={Styles.list}>
                {horario.map(({ dia, horas }) => (
                    <li className={Styles.row} key={dia}>
                        <span className={Styles.dia}>{dia}</span>
                        <span className={Styles.horas}>
                            {horas.map((h, i) => (
                                <span key={i}>{h}</span>
                            ))}
                        </span>
                    </li>
                ))}
            </ul>
        </section>
    );
}

export default Horarios;
